<template>
    <div class="grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-3
        p-4 gap-2">
        <div class=""
            v-for="photo in photos"
            :key="photo.id"
        >
            <router-link :to="`/photos/${photo.id}`">
                <img class="object-fit sm:h-64 sm:w-64 h-32 w-32"
                :src="photo.url">
            </router-link>
        </div>
    </div>
</template>
<script>
import photos from '../../data/photos'
export default {
    name: 'PhotoGrid',
    data() {
        return photos
    }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery/Container.vue